import {useStore} from '../StoreProvider';
import Feature from './Flags';

export default function useFeatureFlag(feature: Feature): boolean | string {
    const store = useStore();
    return store.userData?.experiment?.[feature] ?? false;
}

export {Feature};
